import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  Row,
  Col,
  Select,
  Button,
} from 'antd';

import { formatCell } from '../../helpers';

import { Dialog, Spinner } from '../../components/UI';

import { TableResponsive } from '../../hoc';
import CheckboxItems from '../CheckboxItems';
import TableExport from '../TableExport';

import styles from './DataTable.module.css';

const { Option } = Select;

const subsSize = [
  { id: 1, value: 10 },
  { id: 2, value: 25 },
  { id: 3, value: 50 },
  { id: 4, value: 100 },
];

const createTicket = (action) => {
  return (
    <Button
      type="primary"
      onClick={(event) => action(event, 'create')}
    >
      Create Ticket
    </Button>
  );
};

const BodyWrapper = props => {
  const { children } = props;
  const totalsObj = children.length && children[0].props.totals;

  let totals = [];
  let i = 0;
  for (let key in totalsObj[0]) {
    i++;
    totals.push({
      id: i,
      title: key,
      value: totalsObj[0][key].Value,
      ...totalsObj[0][key]
    });
  }

  return (
    <tbody {...props}>
    <>
      {children}
      {children.length > 0 && (
        <tr className="ant-table-row ant-table-total">
          {totals.map((item, index) => {
            const hiddenClass = item.isHidden ? 'ant-table-cell-hidden' : '';
            return index === 0 ? (
              <td
                key={item.id}
                className={`text-center ${hiddenClass}`}
              >
                Summary:
              </td>
            ) : (
              <td
                key={item.id}
                className={`text-${item.align} ${hiddenClass}`}
              >
                {formatCell(item, item.value)}
              </td>
            )
          })}
        </tr>
      )}
    </>
    </tbody>
  );
};

class DataTable extends PureComponent {
  state = {
    show: false,
    transformedFields: [],
    fields: [],
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.table !== nextProps.table) {
      const table = nextProps.table;
      if (table.data.data !== undefined && table.data.data.length > 0) {
        const transformedFields = Object.values(table.data.fields[0]);

        if (transformedFields.length > 0) {
          this.setState({
            tableName: table.tableName,
            transformedFields,
          })
        }
      }
    }
  }

  editColumns = () => {
    this.setState({
      show: true
    });
  };

  saveColumns = () => {
    const payload = {
      fields: this.state.fields,
      tableName: this.state.tableName,
    };

    this.props.setTableFields(
      payload,
      () => {
        this.props.update();
        this.setState({
          show: false
        });
      }
    );
  };

  toggle = (event) => {
    const { name } = event.target;

    this.setState(({ transformedFields }) => {
      const index = transformedFields.findIndex(el => el.name === name);
      const oldObject = transformedFields[index];
      const newObject = {
        ...oldObject,
        isHidden: !oldObject.isHidden
      };
      const newArray = [
        ...transformedFields.slice(0, index),
        newObject,
        ...transformedFields.slice(index + 1),
      ];

      let fieldsObj = {};
      let copy;
      let fieldsArr = [];
      let i = 0;
      for (let key in this.props.table.data.fields[0]) {
        copy = Object.assign(fieldsObj , {
          [key]: {
            ...newArray[i]
          }
        });

        i++;
      }

      fieldsArr[0] = copy;

      return {
        transformedFields: newArray,
        fields: fieldsArr,
      };
    });
  };

  close = () => {
    this.setState({
      show: false
    });
  };

  render() {
    const {
      loading,
      handleSub,
      rowClassName,
      table,
      update,
    } = this.props;
    const {
      show,
      transformedFields
    } = this.state;

    const dataSource = this.props.table.data && this.props.table.data.data;
    const columns = this.props.table.columns;
    const totals = (this.props.table.data && this.props.table.data.totals) || [];

    const modal = (
      transformedFields ? (
        <div>
          {transformedFields.length > 0 && <CheckboxItems
            list={transformedFields}
            handleChange={this.toggle}
          />}
        </div>
      ) : <Spinner />
    );

    const subs = (
      handleSub && (
        <Select
          style={{width: 100}}
          onChange={handleSub}
          className={styles['masthead-control']}
          defaultValue={10}
        >
          {subsSize.map(({ id, value }) => (
            <Option key={id} value={value}>{value}</Option>
          ))}
        </Select>
      )
    );

    const create = (
      table.toolbar.actions !== undefined && createTicket(table.toolbar.actions[0].create)
    );

    const edit = (
      (update && transformedFields.length > 0) && (
        <Button
          onClick={this.editColumns}
          type="danger"
          ghost
        >
          Columns Visibility
        </Button>
      )
    );

    return (
      <div>
        <div className={styles['table-wrap']}>
          <Row
            type="flex"
            justify="space-between"
            align="middle"
            className={styles['masthead']}
          >
            <Col
              span={12}
              className={styles['masthead-left']}
            >
              {edit}
              {create}
            </Col>
            <Col
              span={12}
              className={styles['masthead-right']}
            >
              <TableExport
                data={table.data}
                title={table.toolbar.titleExport}
              />

              {subs}
            </Col>
          </Row>
          <TableResponsive>
            <Table
              loading={loading}
              columns={columns}
              dataSource={dataSource}
              totals={totals}
              size="middle"
              rowKey="rowId"
              pagination={!!table.pagination}
              components={{body: {wrapper: BodyWrapper}}}
              rowClassName={rowClassName}
              bordered
            />
          </TableResponsive>
        </div>

        <Dialog
          title="Columns Visibility"
          visible={show}
          onOk={this.saveColumns}
          onCancel={this.close}
          content={modal}
        />
      </div>
    );
  }
}

DataTable.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default DataTable;
